import {
  AVAILABLE_LANGUAGES,
  AVAILABLE_LANGUAGE_IDS,
  DEFAULT_LANGUAGE,
  type LanguageOption,
} from '@chargebee/code-sample-generator/browser';

export interface Language {
  name: string;
  key: string;
}

// All languages supported by the code-sample-generator package
export const Languages: Language[] = AVAILABLE_LANGUAGES.map(
  (lang: LanguageOption) => ({
    name: lang.displayName,
    key: lang.lang,
  })
);

export { AVAILABLE_LANGUAGE_IDS, DEFAULT_LANGUAGE };
